(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customizable-media-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (!section || section.dataset.cmtBound === 'true') return;
      section.dataset.cmtBound = 'true';

      if (section.dataset.fadeUp !== 'true') return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('cmt--in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        section.classList.add('cmt--in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.classList.add('cmt--in-view');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    };

    document.querySelectorAll('.cmt[data-fade-up="true"]').forEach(initSection);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('.cmt[data-fade-up="true"]') || event.target.closest?.('.cmt');
      if (section?.dataset?.fadeUp === 'true') {
        section.dataset.cmtBound = 'false';
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-destination-map"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMap = (root) => {
      if (!root || root.dataset.idmBound === 'true') return;
      root.dataset.idmBound = 'true';

      const regions = Array.from(root.querySelectorAll('.idm__region'));
      const triggers = Array.from(root.querySelectorAll('[data-region-trigger]'));
      const cards = Array.from(root.querySelectorAll('.idm__card'));
      const desktopCards = root.querySelector('[data-idm-cards]');
      const mobileSlot = root.querySelector('[data-idm-mobile-slot]');
      const closeButtons = Array.from(root.querySelectorAll('[data-idm-close]'));
      const mq = window.matchMedia('(max-width: 749px)');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let activeId = null;
      let hoverId = null;
      let locked = false;

      const getCard = (id) => cards.find((card) => card.dataset.regionId === id);
      const getRegion = (id) => regions.find((region) => region.dataset.regionId === id);

      const placeCards = () => {
        cards.forEach((card) => {
          if (mq.matches) {
            if (card.dataset.regionId === activeId) {
              mobileSlot.appendChild(card);
            } else if (desktopCards && card.parentElement !== desktopCards) {
              desktopCards.appendChild(card);
            }
          } else if (desktopCards && card.parentElement !== desktopCards) {
            desktopCards.appendChild(card);
          }
        });
      };

      const hideAllCards = () => {
        cards.forEach((card) => {
          card.hidden = true;
          card.setAttribute('aria-hidden', 'true');
        });
      };

      const showCard = (id) => {
        hideAllCards();
        const card = getCard(id);
        if (!card) return;
        placeCards();
        card.hidden = false;
        card.setAttribute('aria-hidden', 'false');
      };

      const updateVisualState = () => {
        const highlightId = locked ? activeId : hoverId || activeId;

        regions.forEach((region) => {
          const id = region.dataset.regionId;
          const shape = region.querySelector('[data-region-trigger]');
          const isActive = id === activeId;
          const isHovered = id === hoverId;
          const isHighlighted = id === highlightId;

          region.classList.toggle('is-active', isActive);
          region.classList.toggle('is-hovered', isHovered || (isHighlighted && !isActive));
          region.classList.toggle('is-dimmed', Boolean(highlightId) && !isHighlighted);

          if (shape) {
            shape.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        });

        if (activeId) {
          showCard(activeId);
        } else if (!mq.matches && hoverId) {
          showCard(hoverId);
        } else {
          hideAllCards();
        }
      };

      const activate = (id, { lock = false } = {}) => {
        activeId = id;
        if (lock) locked = true;
        updateVisualState();
      };

      const clearActive = () => {
        activeId = null;
        locked = false;
        hoverId = null;
        updateVisualState();
      };

      triggers.forEach((trigger) => {
        const region = trigger.closest('.idm__region');
        const id = region?.dataset.regionId;
        if (!id) return;

        trigger.addEventListener('mouseenter', () => {
          if (mq.matches || reduceMotion) return;
          hoverId = id;
          updateVisualState();
        });

        trigger.addEventListener('mouseleave', () => {
          if (mq.matches) return;
          hoverId = null;
          updateVisualState();
        });

        trigger.addEventListener('focus', () => {
          hoverId = id;
          updateVisualState();
        });

        trigger.addEventListener('blur', () => {
          hoverId = null;
          updateVisualState();
        });

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (activeId === id && locked) {
            clearActive();
          } else {
            activate(id, { lock: true });
          }
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            trigger.click();
          }
          if (event.key === 'Escape') {
            clearActive();
          }
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => clearActive());
      });

      const onBreakpointChange = () => {
        placeCards();
        updateVisualState();
      };

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onBreakpointChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onBreakpointChange);
      }

      const defaultSlug = root.dataset.defaultRegion;
      if (defaultSlug && defaultSlug !== 'none') {
        const match = regions.find((region) => region.dataset.regionSlug === defaultSlug);
        if (match) {
          activate(match.dataset.regionId, { lock: true });
        }
      }

      placeCards();
      updateVisualState();
    };

    const boot = () => {
      document.querySelectorAll('.idm[data-section-id]').forEach(initMap);
    };

    boot();

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('.idm') || event.target.closest?.('.idm');
      if (section) {
        section.dataset.idmBound = 'false';
        initMap(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jayhouse-hero"] && !Shopify.designMode) return;
  try {
    
  class JayhouseHero extends HTMLElement {
    connectedCallback() {
      this.#init();
    }

    #init() {
      const hasMobileVideo = this.dataset.hasMobileVideo === 'true';

      if (hasMobileVideo) {
        this.classList.add('jayhouse-hero--has-mobile-video');
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('jayhouse-hero--reduced-motion');
        return;
      }

      this.#setupVideos();
    }

    #setupVideos() {
      const videos = this.querySelectorAll('video');

      if (!videos.length) return;

      videos.forEach((video) => {
        video.setAttribute('playsinline', '');
        video.muted = true;

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            video.style.display = 'none';
          });
        }
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (!(video instanceof HTMLVideoElement)) return;

              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );

        videos.forEach((video) => observer.observe(video));
      }
    }
  }

  if (!customElements.get('jayhouse-hero')) {
    customElements.define('jayhouse-hero', JayhouseHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jayhouse-journey"] && !Shopify.designMode) return;
  try {
    
  class JayhouseJourney extends HTMLElement {
    connectedCallback() {
      this.#init();
    }

    disconnectedCallback() {
      this.#teardown();
    }

    #stages = [];
    #panels = [];
    #rafId = null;
    #ticking = false;
    #reducedMotion = false;
    #activeStageIndex = -1;

    #init() {
      this.#stages = [...this.querySelectorAll('[data-journey-stage]')];
      this.#panels = [...this.querySelectorAll('[data-journey-panel]')];

      if (!this.#stages.length) return;

      this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.#reducedMotion) {
        this.classList.add('jayhouse-journey--reduced-motion');
        this.#panels.forEach((panel) => this.#setProgress(panel, 1, 0, 1));
        this.#playAllVideos();
        return;
      }

      if (this.#panels[0]) {
        this.#setProgress(this.#panels[0], 1, 0, 0.2);
      }

      window.addEventListener('scroll', this.#onScroll, { passive: true });
      window.addEventListener('resize', this.#onScroll, { passive: true });
      this.#onScroll();
    }

    #teardown() {
      window.removeEventListener('scroll', this.#onScroll);
      window.removeEventListener('resize', this.#onScroll);
      if (this.#rafId) cancelAnimationFrame(this.#rafId);
    }

    #onScroll = () => {
      if (this.#ticking) return;
      this.#ticking = true;
      this.#rafId = requestAnimationFrame(() => {
        this.#update();
        this.#ticking = false;
      });
    };

    #smoothstep(edge0, edge1, value) {
      const t = Math.min(1, Math.max(0, (value - edge0) / (edge1 - edge0)));
      return t * t * (3 - 2 * t);
    }

    #update() {
      const viewportHeight = window.innerHeight;
      let nearestIndex = 0;
      let nearestDistance = Infinity;

      this.#stages.forEach((stage, index) => {
        const rect = stage.getBoundingClientRect();
        const panel = this.#panels[index];
        if (!panel) return;

        if (rect.bottom <= 0) {
          this.#setProgress(panel, 1, 0, 1);
          return;
        }

        if (rect.top >= viewportHeight) {
          this.#setProgress(panel, 0, 0, 0);
          return;
        }

        if (index === 0 && rect.top > 0) {
          this.#setProgress(panel, 1, 0, 0);
          return;
        }

        if (index > 0 && rect.top > 0) {
          this.#setProgress(panel, 0, 0, 0);
          return;
        }

        const stageHeight = stage.offsetHeight;
        const scrollRange = Math.max(stageHeight - viewportHeight, 1);
        const scrolled = Math.min(Math.max(-rect.top, 0), scrollRange);
        const progress = scrolled / scrollRange;

        const enterEnd = 0.44;
        const exitStart = 0.97;

        const enter = this.#smoothstep(0, enterEnd, progress);
        const exitRaw = Math.max(0, (progress - exitStart) / (1 - exitStart));
        const exit = exitRaw * exitRaw;
        const drift = this.#smoothstep(enterEnd, exitStart, progress);

        this.#setProgress(panel, enter, exit, drift);

        const centerDistance = Math.abs(rect.top + stageHeight / 2 - viewportHeight / 2);
        if (centerDistance < nearestDistance) {
          nearestDistance = centerDistance;
          nearestIndex = index;
        }
      });

      this.#activeStageIndex = nearestIndex;
      this.#manageVideos();
    }

    #setProgress(panel, enter, exit, drift) {
      const textEnter = this.#smoothstep(0.04, 0.48, enter);

      const mediaOpacity = enter;
      const textOpacity = textEnter;

      panel.style.setProperty('--jh-enter', enter.toFixed(4));
      panel.style.setProperty('--jh-exit', exit.toFixed(4));
      panel.style.setProperty('--jh-drift', drift.toFixed(4));
      panel.style.setProperty('--jh-media-opacity', mediaOpacity.toFixed(4));
      panel.style.setProperty('--jh-text-opacity', textOpacity.toFixed(4));

      const isVisible = enter > 0.08 || exit < 0.95;
      panel.toggleAttribute('data-journey-active', isVisible);
    }

    #manageVideos() {
      this.#panels.forEach((panel) => {
        const videos = panel.querySelectorAll('video');
        if (!videos.length) return;

        const opacity = parseFloat(panel.style.getPropertyValue('--jh-media-opacity')) || 0;
        const shouldPlay = opacity > 0.18;

        videos.forEach((video) => {
          if (shouldPlay) {
            video.muted = true;
            video.setAttribute('playsinline', '');
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    #playAllVideos() {
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      });
    }
  }

  if (!customElements.get('jayhouse-journey')) {
    customElements.define('jayhouse-journey', JayhouseJourney);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jayhouse-story-scroll"] && !Shopify.designMode) return;
  try {
    
  class JayhouseStoryScroll extends HTMLElement {
    connectedCallback() {
      this.#init();
    }

    #init() {
      const items = this.querySelectorAll('[data-story-item]');

      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('jayhouse-story-scroll--reduced-motion');
        items.forEach((item) => item.classList.add('is-visible'));
        this.#playVisibleVideos(items);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const item = entry.target;

            if (entry.isIntersecting) {
              item.classList.add('is-visible');
              this.#playVideos(item);
              observer.unobserve(item);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      items.forEach((item) => observer.observe(item));
    }

    #playVisibleVideos(items) {
      items.forEach((item) => {
        if (this.#isInViewport(item)) {
          this.#playVideos(item);
        }
      });
    }

    #isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    #playVideos(item) {
      item.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      });
    }
  }

  if (!customElements.get('jayhouse-story-scroll')) {
    customElements.define('jayhouse-story-scroll', JayhouseStoryScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
